import { Component, Input } from '@angular/core';
import { DocumentNode } from '@completion/models';

@Component({
  selector: 'app-numbered-list',
  templateUrl: './numbered-list.component.html',
  styleUrls: ['./numbered-list.component.scss'],
  standalone: false,
})
export class NumberedListComponent {
  @Input() nodes: DocumentNode[] = [];
  @Input() documentNode: DocumentNode;
  constructor() {}
}
